import { useState,useEffect } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Select, Space, Spin, Table as AntTable, Tabs, Tag } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import DataType from "../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataType2 from "../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataType3 from "../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataType4 from "../../../Functions/Traitement/DataperiodMCompteRegpt4";
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Alert, Box, Grid, TextField, Typography } from '@mui/material';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import { apiEndpoints } from '../../../config';
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MComptesRegroup';
import Demande from '../../../Models/McomptesPretEtDecouvert';
//import Demande2 from '../../../Models/MComptesOperatSysteme';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import  { ColumnsType } from 'antd/es/table';
import DataPeriod1 from "../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataPeriod2 from "../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataPeriod3 from "../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataPeriod4 from "../../../Functions/Traitement/DataperiodMCompteRegpt4";
import CompteRegroupe from "../../../Models/CompteRegroup";
import { InputAdornment } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import { fetchDataTable, fetchDataTable2 } from "../../../utilitaires/globalFunction";
import { normalizeKeysToUppercase } from "../../../utilitaires/globalFunction";

//pour les commis
let searchCommis: ParamsPicklist = { CodeAgence: '', Table: "COMMIS", Colonne1: "CODCOM", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }


const CompteRegroup = () => {
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Ttable, SetTtable] = useState("")
    const [Nnum, SetNnum] = useState("")
    const [Colon, setColon] = useState("")
    const [Columm, setColumn] = useState<any>()

    const [DataBranch, SetDataBranch] = useState<CompteRegroupe[]>([]);
          const [currentDataBranch, setCurrentDataBranch] = useState<CompteRegroupe | null>(null);
            
        const [searchTerm, setSearchTerm] = useState('');
            const [error, setError] = useState<string | null>(null);
              const [loading2, setLoading2] = useState(false);
            const [choix, setChoix] = useState('I');
        
    const [donnees, setData] = useState<any[]>([]);
    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
    };

    // usestate pour la recherche 
    const [SearchR, SetSearchR] = useState<string>("");




    const dataOption2: DataSelect[] = [
        { label: " Compte de regroupement", value: "PLANCP" },
        { label: " Compte intérêts et commission", value: "IC" },
        { label: " Compte de prêts", value: "TYPEPRET" },
        { label: " Compte produit opération", value: "OPERAT" }
    ]

    //pour la selection de la table
    //let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: Ttable, Colonne1: Nnum, Colonne2: Colon, Colagence: '101', Choix: 22 }
    let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "V_PLANCP_OP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '', Choix: 22 }


    // DECLARATION DES COLONNES DU TABLEAU
    const columns1: ColumnsType<DataType> = [
        {
            title: 'Idplan',
            dataIndex: 'Idplan',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.cptregpt)
                    .toLowerCase()
                    .includes(value.toLowerCase())
                //||
                // String(record.NUMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NOMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.SERVGE)
                //     .toLowerCase()
                //     .includes(value.toLowerCase())
            }

        },
        {
            title: 'codage',
            dataIndex: 'codage',
        },
        {
            title: 'cptregpt',
            dataIndex: 'cptregpt',
        }
    ];

    // DECLARATION DES COLONNES DU TABLEAU
    const columns2: ColumnsType<DataType2> = [
        {
            title: 'CodCom',
            dataIndex: 'CodCom',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.cptregpt)
                    .toLowerCase()
                    .includes(value.toLowerCase())
                //||
                // String(record.NUMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NOMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.SERVGE)
                //     .toLowerCase()
                //     .includes(value.toLowerCase())
            }

        },
        {
            title: 'Numcpt',
            dataIndex: 'Numcpt',
        },
        {
            title: 'CptImp',
            dataIndex: 'CptImp',
        },
        {
            title: 'CptDecouv',
            dataIndex: 'CptDecouv',
        },
        {
            title: 'CptTva',
            dataIndex: 'CptTva',
        },
        {
            title: 'CptFrais',
            dataIndex: 'CptFrais',
        },
        {
            title: 'CptTprcm',
            dataIndex: 'CptTprcm',
        },
        {
            title: 'CptTtvaimp',
            dataIndex: 'CptTtvaimp',
        },
        {
            title: 'codage',
            dataIndex: 'codage',
        }

    ];

    // DECLARATION DES COLONNES DU TABLEAU
    const columns3: ColumnsType<DataType3> = [
        {
            title: 'TYPEPRET',
            dataIndex: 'TYPEPRET',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.cptregpt)
                    .toLowerCase()
                    .includes(value.toLowerCase())
                //||
                // String(record.NUMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NOMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.SERVGE)
                //     .toLowerCase()
                //     .includes(value.toLowerCase())
            }

        },
        {
            title: 'IDPLCPTINTIMP',
            dataIndex: 'IDPLCPTINTIMP',
        },
        {
            title: 'IDPLCPTTVAIMP',
            dataIndex: 'IDPLCPTTVAIMP',
        },
        {
            title: 'IDPLCPTINTPAIE',
            dataIndex: 'IDPLCPTINTPAIE',
        },
        {
            title: 'IDPLCPTCOMPTAX',
            dataIndex: 'IDPLCPTCOMPTAX',
        },
        {
            title: 'IDPLCPTPENPAIE',
            dataIndex: 'IDPLCPTPENPAIE',
        },
        {
            title: 'IDPLCPTPROMESS',
            dataIndex: 'IDPLCPTPROMESS',
        },
        {
            title: 'IDPLCPTGARAN',
            dataIndex: 'IDPLCPTGARAN',
        },
        {
            title: 'IDPLCPTINTDOUT',
            dataIndex: 'IDPLCPTINTDOUT',
        },
        {
            title: 'IDPLCPTTVADOUT',
            dataIndex: 'IDPLCPTTVADOUT',
        },
        {
            title: 'IDPLCPTPROVCRDOUT',
            dataIndex: 'IDPLCPTPROVCRDOUT',
        },
        {
            title: 'CODAGE',
            dataIndex: 'CODAGE',
        }

    ];

    // DECLARATION DES COLONNES DU TABLEAU
    const columns4: ColumnsType<DataType4> = [
        {
            title: 'CODOPE',
            dataIndex: 'CODOPE',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.cptregpt)
                    .toLowerCase()
                    .includes(value.toLowerCase())
                //||
                // String(record.NUMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NOMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.SERVGE)
                //     .toLowerCase()
                //     .includes(value.toLowerCase())
            }

        },
        {
            title: 'NUMCPT',
            dataIndex: 'NUMCPT',
        },
        {
            title: 'CODAGE',
            dataIndex: 'CODAGE',
        }
    ];

    useEffect(() => {
         // setChoix('I');
          //alert('yetoo'+choix)
            loadAllDataBranch();
        }, [choix]);

        

    function Getselectcli() {
        setData([])
        form.setFieldValue("idplan", "")
        form.setFieldValue("lib_idplan", "")
            SetTtable("PLANCP")
            SetNnum("IDPLAN")
            setColon("LIBELL")
            setColumn(columns1)

        // if (form.getFieldValue("categorie") == "PLANCP") {

        //     SetTtable("PLANCP")
        //     SetNnum("IDPLAN")
        //     setColon("LIBELL")
        //     setColumn(columns1)

        // } else if (form.getFieldValue("categorie") == "IC") {
        //     SetTtable("COMMIS")
        //     SetNnum("CODCOM")
        //     setColon("LIBELL")
        //     setColumn(columns2)
        // } else if (form.getFieldValue("categorie") == "TYPEPRET") {
        //     SetTtable("TYPEPRET")
        //     SetNnum("TYPEPRET")
        //     setColon("LIBELLE")
        //     setColumn(columns3)
        // } else if (form.getFieldValue("categorie") == "OPERAT") {
        //     SetTtable("OPERAT")
        //     SetNnum("CODOPE")
        //     setColon("LIBELL")
        //     setColumn(columns4)
        // } else {
        //     SetTtable("")
        //     SetNnum("")
        //     setColumn("")
        // }
    }

       // Fonction pour convertir un objet avec des clés en majuscules
   
    // 📄 Filtrage des données en fonction du terme de recherche
      const filteredDataBranch = DataBranch.filter((item) =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      // 📄 Pagination gérée par le tableau (antd)
      // --- Charge le plan de la ligne dans le mapping (tab 1) : exploration ---
      const explorerPlan = (item: CompteRegroupe) => {
        form.setFieldValue('IDPLAN', item.IDPLAN);
        chargerAgencesReg();
        setActiveTab('1'); // bascule sur l'onglet de mapping
      };

      // --- valide une ligne (compte) via sp_AnyManageComptesRegroup/VALIDER ---
      const validerLigne = (item: CompteRegroupe) => {
        SweetAlert.fire({
          title: 'Valider',
          text: `Valider le compte ${item.CPTREGPT} de l'agence ${item.CODAGE} ?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#116599',
          cancelButtonColor: 'darkred',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non'
        }).then(async (r) => {
          if (!r.isConfirmed) return;
          setLoading(true);
          try {
            const res = await appelCptRegroup({
              Action: 'VALIDER',
              IdPlan: item.IDPLAN,
              Codage: item.CODAGE,
              Numcpt: item.CPTREGPT,
              Utilisateur: Perss.coduti
            });
            if (res?.StatutCode === 200) {
              SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
            } else {
              SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
            }
          } catch (e: any) {
            SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
          }
          setLoading(false);
          loadAllDataBranch();
          if (planSel === item.IDPLAN) chargerAgencesReg();
        });
      };

      // --- supprime une ligne (compte) via sp_AnyManageComptesRegroup/SUPPRIMER ---
      const supprimerLigne = (item: CompteRegroupe) => {
        SweetAlert.fire({
          title: 'Supprimer',
          text: `Supprimer le compte ${item.CPTREGPT} de l'agence ${item.CODAGE} ?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#116599',
          cancelButtonColor: 'darkred',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non'
        }).then(async (r) => {
          if (!r.isConfirmed) return;
          setLoading(true);
          try {
            const res = await appelCptRegroup({
              Action: 'SUPPRIMER',
              IdPlan: item.IDPLAN,
              Codage: item.CODAGE,
              Numcpt: item.CPTREGPT,
              Utilisateur: Perss.coduti
            });
            if (res?.StatutCode === 200) {
              SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
            } else {
              SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
            }
          } catch (e: any) {
            SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
          }
          setLoading(false);
          loadAllDataBranch();
          if (planSel === item.IDPLAN) chargerAgencesReg();
        });
      };

      // Colonnes du tableau de consultation (mappings existants)
      const colonnesListeReg = [
        {
          title: 'Plan', dataIndex: 'IDPLAN', width: 110,
          sorter: (a: any, b: any) => String(a.IDPLAN ?? '').localeCompare(String(b.IDPLAN ?? ''))
        },
        {
          title: 'Agence', dataIndex: 'CODAGE', width: 90,
          sorter: (a: any, b: any) => String(a.CODAGE ?? '').localeCompare(String(b.CODAGE ?? ''))
        },
        {
          title: 'Compte', dataIndex: 'CPTREGPT', width: 130,
          sorter: (a: any, b: any) => String(a.CPTREGPT ?? '').localeCompare(String(b.CPTREGPT ?? ''))
        },
        {
          title: 'Intitulé', dataIndex: 'NOMCPT',
          render: (v: any) => v ?? '—'
        },
        {
          title: 'Statut', dataIndex: 'UTIVAL', width: 110,
          render: (v: any) => String(v ?? '').trim() !== ''
            ? <Tag color='green'>Validé</Tag>
            : <Tag color='orange'>En attente</Tag>,
          filters: [
            { text: 'Validé', value: 'valide' },
            { text: 'En attente', value: 'attente' }
          ],
          onFilter: (v: any, r: any) => (String(r.UTIVAL ?? '').trim() !== '') === (v === 'valide')
        },
        {
          title: 'Créé le', dataIndex: 'DATCRE', width: 100,
          render: (v: any) => v ? new Date(v).toLocaleDateString() : '—',
          sorter: (a: any, b: any) => String(a.DATCRE ?? '').localeCompare(String(b.DATCRE ?? ''))
        },
        {
          title: 'Par', dataIndex: 'UTILIS', width: 80,
          render: (v: any) => v ?? '—'
        },
        {
          title: 'Validé le', dataIndex: 'DATVAL', width: 100,
          render: (v: any) => v ? new Date(v).toLocaleDateString() : '—',
          sorter: (a: any, b: any) => String(a.DATVAL ?? '').localeCompare(String(b.DATVAL ?? ''))
        },
        {
          title: 'Par', dataIndex: 'UTIVAL', width: 80,
          render: (v: any) => (String(v ?? '').trim() !== '' ? v : '—')
        },
        {
          title: 'Actions', width: 240, fixed: 'right' as const,
          render: (_: any, r: CompteRegroupe) => {
            const valide = String(r.UTIVAL ?? '').trim() !== '';
            return (
              <Space size={2} wrap>
                <Button size='small' onClick={() => explorerPlan(r)}>Voir</Button>
                {!valide && <Button size='small' type='primary' style={{ backgroundColor: '#116599' }} onClick={() => validerLigne(r)}>Valider</Button>}
                {!valide && <Button size='small' danger onClick={() => supprimerLigne(r)}>Suppr.</Button>}
              </Space>
            );
          }
        }
      ];

        async function loadAllDataBranch() {
          
             setLoading2(true);
            setError(null);
            try {
            
         // console.log(apiEndpoints.bureaux)
          var params = { CodeAgence: Perss.codage , Table: "COMPTESREGROUP", Colonne1: "IDPLAN", Colonne2: "CPTREGPT", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
          console.log(params)
          const data = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
          
          if (data.length!==0)
             {
        // alter(data.result)
          //console.log(data)
          SetDataBranch(normalizeKeysToUppercase(data)); // ou console.log(data)
             }
            }catch (err) {
          console.error("Erreur de chargement:", err);
          setError("Impossible de charger les données .");
         } finally {
          setLoading2(false);
         }
        } ;

    // ====================================================================
    // NOUVEAU FLOW : comptes de regroupement par plan comptable
    // Choix du plan (IDPLAN) -> toutes les agences -> selection des comptes
    // GL (deja crees dans COMPTES) par agence -> enregistrement en masse.
    // Meme logique que les comptes contrepartie, sans cote part.
    // ====================================================================
    interface CompteRegChoisi {
        numcpt: string;
        nomcpt: string;
        /** true = ligne validee en base (UTIVAL renseigne) : non modifiable. */
        locked: boolean;
    }

    const [planSel, setPlanSel] = useState('');
    const [activeTab, setActiveTab] = useState('1');
    const [agencesReg, setAgencesReg] = useState<{ codage: string; libelle: string; nbComptes: number }[]>([]);
    const [mapComptesReg, setMapComptesReg] = useState<Record<string, CompteRegChoisi[]>>({});
    const [optComptesReg, setOptComptesReg] = useState<Record<string, { value: string; label: string; disabled?: boolean }[]>>({});

    const appelCptRegroup = async (payload: any): Promise<any> => {
        const cypher = Crypter.encrypt(JSON.stringify(payload));
        const res = await axios.post(`${apiEndpoints.compteRegroup}/GererComptesRegroup`, null, {
            headers: { 'CypherGpt': cypher, 'Authorization': authHeader(), 'Content-Type': 'application/json' }
        });
        const raw = JSON.parse(Crypter.decrypt(res.data));
        return raw.Value ?? raw;
    };

    const chargerAgencesReg = async () => {
        const idplan = String(form.getFieldValue('IDPLAN') ?? '').trim();
        if (!idplan) {
            SweetAlert.fire({ title: 'Plan comptable requis', icon: 'warning' });
            return;
        }
        setLoading(true);
        try {
            const [resA, resL] = await Promise.all([
                appelCptRegroup({ Action: 'AGENCES', IdPlan: idplan }),
                appelCptRegroup({ Action: 'LISTE', IdPlan: idplan })
            ]);
            const ags = resA?.Result?.Table ?? [];
            setAgencesReg(ags.map((a: any) => ({
                codage: String(a.codage ?? a.CODAGE ?? ''),
                libelle: String(a.libelle ?? a.LIBELLE ?? ''),
                nbComptes: Number(a.nbComptes ?? a.NBCOMPTES ?? 0)
            })));
            const map: Record<string, CompteRegChoisi[]> = {};
            (resL?.Result?.Table ?? []).forEach((r: any) => {
                const ag = String(r.codage ?? r.CODAGE ?? '');
                const nc = String(r.cptregpt ?? r.CPTREGPT ?? '');
                if (!ag || !nc) return;
                (map[ag] = map[ag] ?? []).push({
                    numcpt: nc,
                    nomcpt: String(r.nomcpt ?? r.NOMCPT ?? ''),
                    locked: String(r.utival ?? r.UTIVAL ?? '').trim() !== ''
                });
            });
            setMapComptesReg(map);
            setOptComptesReg({});
            setPlanSel(idplan);
        } catch (e: any) {
            SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
        }
        setLoading(false);
    };

    // Charge les comptes GL de l'agence a l'ouverture de la liste (une fois)
    const chargerComptesAgenceReg = async (codage: string) => {
        if (optComptesReg[codage]) return;
        try {
            const res = await appelCptRegroup({ Action: 'COMPTES', Codage: codage });
            const opts = (res?.Result?.Table ?? []).map((c: any) => {
                const nc = String(c.numcpt ?? c.NUMCPT ?? '');
                return {
                    value: nc,
                    label: `${nc} - ${String(c.nomcpt ?? c.NOMCPT ?? '')}`
                };
            });
            setOptComptesReg(prev => ({ ...prev, [codage]: opts }));
        } catch (e: any) {
            console.log(e);
        }
    };

    const ajouterCompteReg = (codage: string, numcpt: string) => {
        const opt = (optComptesReg[codage] ?? []).find(o => o.value === numcpt);
        const nom = opt ? String(opt.label).replace(`${numcpt} - `, '') : '';
        setMapComptesReg(prev => {
            const lignes = prev[codage] ?? [];
            if (lignes.some(c => c.numcpt === numcpt)) return prev;
            return { ...prev, [codage]: [...lignes, { numcpt, nomcpt: nom, locked: false }] };
        });
    };

    const retirerCompteReg = (codage: string, idx: number) => {
        setMapComptesReg(prev => {
            const lignes = [...(prev[codage] ?? [])];
            if (lignes[idx]?.locked) return prev;
            lignes.splice(idx, 1);
            return { ...prev, [codage]: lignes };
        });
    };

    const enregistrerRegroup = async () => {
        if (!planSel) return;
        setLoading(true);
        try {
            const items = agencesReg.map(a => ({
                Codage: a.codage,
                Comptes: (mapComptesReg[a.codage] ?? []).map(c => ({ Numcpt: c.numcpt }))
            }));
            const res = await appelCptRegroup({
                Action: 'ENREGISTRER',
                IdPlan: planSel,
                Utilisateur: Perss.coduti,
                Items: items
            });
            if (res?.StatutCode === 200) {
                SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                chargerAgencesReg();
                loadAllDataBranch();
            } else {
                SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
            }
        } catch (e: any) {
            SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
        }
        setLoading(false);
    };

    // Valide toutes les lignes non encore validees du plan affiche (action VALIDER, IdPlan seul)
    const validerPlan = () => {
        if (!planSel) return;
        SweetAlert.fire({
            title: 'Valider',
            text: `Valider tous les comptes de regroupement du plan ${planSel} ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (r) => {
            if (!r.isConfirmed) return;
            setLoading(true);
            try {
                const res = await appelCptRegroup({
                    Action: 'VALIDER',
                    IdPlan: planSel,
                    Utilisateur: Perss.coduti
                });
                if (res?.StatutCode === 200) {
                    SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoading(false);
            loadAllDataBranch();
            chargerAgencesReg();
        });
    };

    const colonnesAgencesReg = [
        {
            title: 'Agence', width: 230,
            render: (_: any, r: any) => <span><b>{r.codage}</b> — {r.libelle}</span>
        },
        {
            title: 'Comptes GL de regroupement',
            render: (_: any, r: any) => {
                const lignes = mapComptesReg[r.codage] ?? [];
                return (
                    <div>
                        {lignes.map((c, i) => (
                            <div key={c.numcpt} style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                                <Tag color={c.locked ? 'green' : 'blue'} style={{ marginRight: 0 }}>{c.numcpt}</Tag>
                                <span style={{ flex: 1, fontSize: 12, color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {c.nomcpt}
                                </span>
                                <Button size='small' danger type='text' disabled={c.locked}
                                    icon={<DeleteIcon style={{ fontSize: 16 }} />}
                                    onClick={() => retirerCompteReg(r.codage, i)} />
                            </div>
                        ))}
                        <Select
                            size='small'
                            showSearch
                            optionFilterProp='label'
                            style={{ width: '100%' }}
                            placeholder='+ Ajouter un compte GL'
                            value={null}
                            onDropdownVisibleChange={(open: boolean) => { if (open) chargerComptesAgenceReg(r.codage); }}
                            options={(optComptesReg[r.codage] ?? []).map(o => ({
                                ...o,
                                disabled: lignes.some(c => c.numcpt === o.value)
                            }))}
                            onChange={(v: string) => ajouterCompteReg(r.codage, v)}
                        />
                    </div>
                );
            }
        },
        {
            title: 'Nb', width: 60, align: 'center' as const,
            render: (_: any, r: any) => (mapComptesReg[r.codage] ?? []).length
        }
    ];

    // Liste des mappings existants : contenu du 2eme onglet, positionnee en haut
    // avec le meme squelette (Box .border + fieldset .bordure1) que l'onglet 1
    const listeRegroupement = (
        <Box fontStyle="inherit" className="border" sx={{ width: '85%', minWidth: 0, boxSizing: 'border-box' }}>
            <legend style={{ textAlign: 'center', paddingLeft: 10, borderRadius: 10 }}>
                Liste des comptes de regroupement
            </legend>
            <fieldset className="bordure1" style={{ width: '100%', boxSizing: 'border-box', marginTop: -20, padding: '16px', minWidth: 0 }}>
            <Box sx={{ width: '100%', overflowX: 'auto' }}>
                {/* Zone de recherche */}
                <Box sx={{ mb: 2 }}>
                    <TextField
                        label="Recherche"
                        variant="outlined"
                        fullWidth
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                        }}
                        size="small"
                        InputLabelProps={{
                            sx: { fontWeight: 'bold' },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon color="action" />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                {/* Tableau des mappings existants (consultation / exploration) */}
                <AntTable
                    size='small'
                    columns={colonnesListeReg as any}
                    dataSource={filteredDataBranch}
                    rowKey={(r: any) => `${r.IDPLAN ?? ''}-${r.CODAGE ?? ''}-${r.CPTREGPT ?? ''}`}
                    loading={loading2}
                    scroll={{ y: 320, x: 'max-content' }}
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                        pageSizeOptions: [10, 25, 50, 100],
                        showTotal: (t: number) => `${t} ligne(s)`
                    }}
                />
            </Box>
            </fieldset>
        </Box>
    );

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Génération Comptes regroupememnt
                </span>
            ),
            children: <>
                <div className='tabItem' >

                  
  <Box
  fontStyle="inherit"
  className="border"
    sx={{
    // 85% : le panneau Actions (.bG) recouvre la zone a droite de ~89% (CSS .bG left:89%)
    // minWidth:0 : .tabItem est en display:flex -> sans cela le contenu large
    // (tableaux) etire le conteneur au lieu de scroller en interne
    width: '85%',
    minWidth: 0,
    boxSizing: 'border-box',
  }}
  >
    <legend style={{ textAlign: 'center', paddingLeft: 10, borderRadius: 10 }}>
      Comptes de regroupement par plan comptable
    </legend>

    {/* ----------- Premier Fieldset : mapping plan -> agences -> comptes GL ----------- */}
    <fieldset
      className="bordure1"
      style={{
        // minWidth:0 : <fieldset> a min-width:min-content par defaut -> sans cela
        // il depasse le conteneur quand le tableau est plus large
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        marginTop: -20,
        padding: '16px',
      }}
    >
      <Grid container spacing={0} alignItems="center">
        <Grid item xs={12}>
          <SearchModal
            disabled={false}
            width={0}
            Titre="Recherche du plan comptable"
            label="Plan comptable"
            name="IDPLAN"
            Taille1="100%"
            Parametre={searchPlancp}
            Taille2="100%"
            form={form}
            ExecuteafterSelect1={() => chargerAgencesReg()}
          />
        </Grid>
      </Grid>

      <Box sx={{ overflowX: 'auto', width: '100%', marginTop: 2 }}>
        {agencesReg.length === 0 ? (
          <Box style={{ textAlign: 'center', color: '#999', margin: 16 }}>
            Sélectionnez un plan comptable pour afficher les agences
          </Box>
        ) : (
          <>
            <AntTable
              size='small'
              columns={colonnesAgencesReg as any}
              dataSource={agencesReg}
              rowKey={(r: any) => r.codage}
              pagination={false}
              scroll={{ y: 380, x: 'max-content' }}
            />
            <Box style={{ marginTop: 12, textAlign: 'right' }}>
              <Tag color='orange' style={{ marginRight: 8 }}>
                Les lignes validées ne sont pas modifiables
              </Tag>
              <Tag color='geekblue'>
                Enregistrement via le panneau Actions
              </Tag>
            </Box>
          </>
        )}
      </Box>
    </fieldset>
  </Box>


                </div >
            </>,
        },
        {
            key: '2',
            label: (
                <span id='x'>
                    <UsergroupAddOutlined />
                    Liste comptes regroupement
                </span>
            ),
            children: <div className='tabItem'>{listeRegroupement}</div>,
        }
    ];


    function consult() {



    }


    // function Onfinish
    const onFinish = (values: any) => {
        var CompteReg: Demand = values;
        CompteReg.idcptregpt = currentDataBranch?.IDCPTREGPT ||0;//CompteReg.idcptregpt;
        CompteReg.idplan =  form.getFieldValue("IDPLAN") //CompteReg.idplan;
         CompteReg.codage = Perss.codage;
        CompteReg.cptregpt = form.getFieldValue("CPTREGPT") //CompteReg.cptregpt;
        CompteReg.utilis = Perss.coduti;
        CompteReg.datcre=Perss.datjour;
        CompteReg.utival=Perss.coduti;
        CompteReg.datval=Perss.datjour
         CompteReg.choix = choix;                    
        CompteReg.libelle = form.getFieldValue("NOMCPT") //CompteReg.libelle;
        //CompteReg.nomcpt = choix;
        let data = Crypter.encrypt(JSON.stringify(CompteReg));
        
        // ************* pour le consult 
        if (sbmit == 'Consult') {
            loadAllDataBranch();           
            // ************* mis a jour  *********************
        } else if (sbmit=='Enreg'){
            // alert("yeteooo aaa")
           // alert(data)
            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCptreg,
                                headers: {
                                'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
            SweetAlert.fire({})
      
        } else if (sbmit=='Add'){
           // alert("modif")
                if (form.getFieldValue("IDPLAN") != "") {
                            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCptreg,
                                headers: {
                                    'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
                        }else {
                            SweetAlert.fire({ title: "Warning", text: "Veuillez remplir le champ Plan Comptable", icon: "warning" })
                        }
        }
    }
   



    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir le champs obligatoire", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir le champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                {/* <Form disabled={!FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}> */}
                 <Form disabled={!FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish}  style={{ minWidth: 'auto', maxWidth: 'auto' }}>

                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                {/* Recharge le listing + le mapping du plan affiche */}
                                <Button size='large' className='bt_add' disabled={loading}
                                    onClick={() => { loadAllDataBranch(); if (planSel) chargerAgencesReg(); }}
                                    type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                {/* Enregistre en masse les comptes de regroupement du plan (onglet 1) */}
                                <Button size='large' className='bt_add' disabled={!planSel || agencesReg.length === 0 || loading}
                                    onClick={enregistrerRegroup}
                                    type="ghost" htmlType="button" block>
                                    Enregistrer
                                </Button>
                                {/* Valide toutes les lignes non validees du plan affiche */}
                                <Button size='large' className='bt_add' disabled={!planSel || loading}
                                    onClick={validerPlan}
                                    type="ghost" htmlType="button" block>
                                    Valider
                                </Button>
                                <Button size='large' className='bt_add'
                                    onClick={() => {
                                        form.resetFields(); setData([]); setChoix('I');
                                        setPlanSel(''); setAgencesReg([]); setMapComptesReg({}); setOptComptesReg({});
                                        setSearchTerm('');
                                    }}
                                    type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" activeKey={activeTab} onChange={setActiveTab} items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default CompteRegroup;